module.exports = __webpack_public_path__ + "static/media/veron.57fac945.png";